import React, { useEffect, useState, useCallback, useRef } from "react";
import api from "../services/api";
import "../assets/css/style.css";
import AdminAspirantsParRegionChart from "../components/admin/AdminAspirantsParRegionChart";
import AdminAspirantsExplorer from "../components/admin/AdminAspirantsExplorer";

export default function DashboardRegion() {
  const [aspirants, setAspirants] = useState([]);
  const [memoires, setMemoires] = useState([]);
  const [stats, setStats] = useState({ total: 0, total_CG: 0, total_SYL: 0 });
  const [loadingStats, setLoadingStats] = useState(false);
  const [errStats, setErrStats] = useState("");
  const [isRefreshing, setIsRefreshing] = useState(false);
  const refreshIntervalRef = useRef(null);

  // Fonction pour charger toutes les données
  const loadData = useCallback(async (showLoading = false) => {
    if (showLoading) {
      setIsRefreshing(true);
    }

    try {
      // Charger les aspirants
      api.get("/region/aspirants")
        .then((res) => setAspirants(res.data))
        .catch((err) => console.error("Erreur chargement aspirants:", err));

      // Charger les mémoires
      api.get("/region/memoires/en_attente")
        .then((res) => setMemoires(res.data))
        .catch((err) => console.error("Erreur chargement memoires:", err));

      // Charger les statistiques
      if (showLoading) {
        setLoadingStats(true);
      }
      api.get("/adminStats/aspirants")
        .then((res) => {
          setStats(res.data);
          setErrStats("");
        })
        .catch((err) => {
          console.error("Erreur chargement stats aspirants:", err);
          setErrStats(err?.response?.data?.error || "Erreur chargement statistiques");
        })
        .finally(() => {
          setLoadingStats(false);
          if (showLoading) {
            setIsRefreshing(false);
          }
        });
    } catch (error) {
      console.error("Erreur lors du chargement des données:", error);
      if (showLoading) {
        setIsRefreshing(false);
      }
    }
  }, []);

  // Chargement initial
  useEffect(() => {
    loadData(true);

    // Rafraîchissement automatique toutes les 5 minutes (300000 ms)
    refreshIntervalRef.current = setInterval(() => {
      console.log("Rafraîchissement automatique des données...");
      loadData(false);
    }, 300000); // 5 minutes

    // Nettoyage à la destruction du composant
    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, [loadData]);

  // Fonction de rafraîchissement manuel
  const handleRefresh = () => {
    loadData(true);
  };

  return (
    <div className="container-fluid mt-4">
      <main className="flex-grow-1 overflow-auto p-4 bg-surface-secondary py-2">
        <header className="pt-6 mb-4">
          <div className="container-fluid">
            <div className="mb-npx">
              <div className="row align-items-center">
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center">
                    <h1 className="h2 mb-0 ls-tight">Tableau de bord Admin</h1>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={handleRefresh}
                      disabled={isRefreshing}
                      title="Rafraîchir les données"
                    >
                      <i className={`bi bi-arrow-clockwise ${isRefreshing ? "spinning" : ""}`}></i>
                      {isRefreshing ? " Actualisation..." : " Actualiser"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="container-fluid mb-4">
          {errStats && <div className="alert alert-danger">{errStats}</div>}
          <div className="row g-3">
            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "rgb(199 212 223)" }}>
                <div className="card-body">
                  <h6 className="card-title"><i className="bi bi-people-fill me-2"></i>Total Elèves</h6>
                  <h3 className="mb-0">{loadingStats ? "…" : stats.total}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "#0d6efd" }}>
                <div className="card-body">
                  <h6 className="card-title card-title2">
                    <i className="bi bi-person-check-fill me-2"></i>
                    <span className="d-inline d-md-none">Elèves CG</span>
                    <span className="d-none d-md-inline">Elèves Chef Guide</span>
                  </h6>
                  <h3 className="mb-0">{loadingStats ? "…" : stats.total_CG}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "#6e0b14" }}>
                <div className="card-body">
                  <h6 className="card-title card-title2 "><i className="bi bi-person-badge-fill me-2"></i>Elèves SYL</h6>
                  <h3 className="mb-0">{loadingStats ? "…" : stats.total_SYL}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid mb-4">
            <div className="d-none d-md-block">
              <AdminAspirantsParRegionChart />
            </div>
          {/* {/* <div className="py-5"> */}
            <AdminAspirantsExplorer />
          {/* </div> */} 
        </div>
      </main>
    </div>
  );
}
